module.exports = __webpack_public_path__ + "static/media/VMWM_IPO_General_Terms_and_Conditions.9865648c.pdf";